
import { Component, Ref, Vue } from 'nuxt-property-decorator'
import { MetaInfo } from 'vue-meta'

import { AnalyticsOffersList } from '@alao-frontend/analytics.plugin'
import BPPageBody from '~/components/promos/black-promo/BPPageBody.vue'
import BPHeader from '~/components/promos/black-promo/BPHeader.vue'
import BPMobileDeals from '~/components/promos/black-promo/BPDeals/BPMobileDeals.vue'
import BPHomeDeals from '~/components/promos/black-promo/BPDeals/BPHomeDeals.vue'
import BPWhyAlao from '~/components/promos/black-promo/BPWhyAlao.vue'
import BPHiw from '~/components/promos/black-promo/BPHiw.vue'
import BPClientsFeedback from '~/components/promos/black-promo/BPClientsFeedback.vue'
import BPPartners from '~/components/promos/black-promo/BPPartners.vue'
import BPFooter from '~/components/promos/black-promo/BPFooter.vue'

import SaveRouteMixin from '~/mixins/save-route.mixin'
import BPSection from '~/components/promos/black-promo/snippets/BPSection.vue'
import { useSEOMetaComposer } from '~/composables/seo.composable'

@Component({
  components: {
    BPSection,
    BPPageBody,
    BPHeader,
    BPMobileDeals,
    BPHomeDeals,
    BPWhyAlao,
    BPHiw,
    BPClientsFeedback,
    BPPartners,
    BPFooter,
  },
  mixins: [SaveRouteMixin],
  layout: 'no-footer',
})
export default class BlackSeptemberPage extends Vue {
  @Ref('mobileDealsRef')
  readonly mobileDealsRef!: BPHomeDeals

  readonly listPosition = AnalyticsOffersList.BLACK_SEPTEMBER_OFFER

  head (): MetaInfo {
    return useSEOMetaComposer(
      this,
      {
        title: this.$t('head.meta.blackSeptember.title').toString(),
        description: this.$t(
          'head.meta.blackSeptember.description',
        ).toString(),
        route: { name: 'black-september-index' },
      },
    )
  }

  onHeaderCTAClick () {
    this.$scrollTo(this.mobileDealsRef.$el, 300, {
      offset: -80,
    })
  }

  mounted (): void {
    this.$analytics.GTM.sendPageViewEvent({
      routeName: this.$route.name as string,
      pageTitle: this.$metaInfo.title || '',
      fullPath: this.$route.fullPath,
      fromPath: this.$nuxt.context.from ? this.$nuxt.context.from.fullPath : '',
      contentGroup: 'Black September',
    })
  }
}
